import { HttpClient, HttpEventType } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { MainService } from './main.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { LedgerService } from './ledger.service';

import { HierarchyService } from "../service/hierarchy.service";
import Swal from 'sweetalert2';
import { BpService } from './bp.service';
import { BillService } from './bill.service';
import { BudgetEffectService } from './budget-effect.service';
import { RuleProcessingNewService } from './rule-processing-new.service';
import { EventGroupService } from './event-group.service';
import { LogService } from '../../portal/service/log.service';
import { SettingService } from './setting.service';
import { CreateEventService } from './create-event.service';
import { session } from 'src/environments/environment.session';
import { ReimbursementService } from './reimbursement.service';
import { Utf8EncodingService } from 'src/app/md/service/utf8-encoding.service';


@Injectable({
  providedIn: 'root'
})
export class ProcessDocumentService {

  httpUrl;
  erpUser;
  b_acct_id;
  current_date: any
  // systemDate: any
  constructor(
    // private http: HttpClient, 
    private spinner: NgxSpinnerService,
    private main: MainService, private ledgerService: LedgerService,
    // private contraService: ContraService,
    private BPS: BpService, private billService: BillService,

    private budgetEffectService: BudgetEffectService,
    private ruleProcessingNewService: RuleProcessingNewService,
    private eventGroupService: EventGroupService,
    private hierarchyService: HierarchyService,
    private settingService: SettingService,
    private createEventService: CreateEventService,private utf8EncodingService:Utf8EncodingService,
    private log: LogService, private reimbursementService: ReimbursementService

  ) {
    this.httpUrl = this.main.httpUrl + "/account/event";
    this.erpUser = this.utf8EncodingService.decodeFromUtf8((session.erpUser));
    this.b_acct_id = this.erpUser.b_acct_id;
    this.current_date = new Date().toISOString().split('T')[0]
  }

  // allChartOfAccount = []
  ChartOfAccountObj: any = {}
  async getChartOfAccount() {
    this.spinner.show();
    let obj: any = new Object();
    obj["b_acct_id"] = this.b_acct_id;
    let resp = await this.ledgerService.getchartofaccount(JSON.stringify(obj));
    if (resp["error"] == false) {
      const allChartOfAccount = resp.data;
      allChartOfAccount.map((x: any) => {
        this.ChartOfAccountObj[x['leaf_code']] = x['leaf_value']
      })
      this.spinner.hide();
    } else {
      this.spinner.hide();
      Swal.fire("ERROR", "Error while getting  all chart of account info", "error");
    }
  }

  fin_year: number = 0;
  async FinYear() {
    let obj: any = new Object();
    obj["b_acct_id"] = this.b_acct_id;
    let resp = await this.ledgerService.getActiveFinYear(JSON.stringify(obj));
    if (resp["error"] == false) {
      if (resp.data.length == 0) {
        Swal.fire("WARNING", "Active Financial Year Not set!", "warning");
      } else {
        this.fin_year = resp.data[0].fin_year;
      }
    } else {
      Swal.fire("ERROR", "Error while getting active  fin year", "error");
    }
  }

  prohierObj: any = {}
  async getAllProject() {
    var obj: any = new Object();
    obj["b_acct_id"] = this.b_acct_id;
    obj["table_name"] = "proj_hier";
    var resp = await this.hierarchyService.getProjectHierarchy(obj);
    if (resp["error"] == false) {
      resp.data.map((x: any) => {
        this.prohierObj[x['leaf_cd']] = x['leaf_value']
        this.projectLeafUserObj[x["leaf_user_cd"]] = x;
        this.hierobj["project"][x['leaf_cd']] = x
      })
    } else {
    }
  }

  /************************************Posting of manual journla start ***************************************************** */


  async postManualJournal(element: any) {

    await this.getChartOfAccount();
    await this.FinYear();
    await this.getAllProject();

    this.spinner.show();
    const d = new Date();
    let month = d.getMonth();
    let data = [];

    let fetcObj: any = {}
    fetcObj['b_acct_id'] = this.b_acct_id;
    fetcObj['id'] = element.doc_local_no;
    let manual_jrnl = await this.ledgerService.getManulaJournalById(JSON.stringify(fetcObj));

    let bud_obj = await this.budgetEffectService.getBudgetObjForManualJournal(manual_jrnl["data"][0], this.b_acct_id);
    if (bud_obj['error'] === true) {
      this.spinner.hide();
      Swal.fire("Error", bud_obj['data'], 'error');
      return false;
    }

    if (manual_jrnl['error'] == false) {
      let all_account_lines = JSON.parse(manual_jrnl['data'][0]['data_lines']);
      for (let i = 0; i < all_account_lines.length; i++) {
        if (all_account_lines[i]["type"] == "credit") {
          let ob: any = new Object();

          ob["arr_id"] = manual_jrnl['data'][0]["jrnl_id"];
          ob["ar_cntr_ip_id"] =
            all_account_lines[i]["data"]["ar_cntr_ip_id"];
          ob["ar_cntr_ip_name"] = all_account_lines[i]["data"]["ar_cntr_ip_id"] === 420 ? 'BENEFICIARY' : all_account_lines[i]["data"]["ar_cntr_ip_name"];
          ob["event_id"] = manual_jrnl['data'][0]['id']
          ob["ld_prj_cd"] = all_account_lines[i]['data']["proj_cd"];
          ob["ld_act_cd"] = all_account_lines[i]['data']["act_cd"];
          ob["ld_pd_cd"] = all_account_lines[i]['data']["prod_cd"];
          ob["ld_bugt_cd"] = all_account_lines[i]['data']["bud_cd"];
          ob["txn_amt"] = all_account_lines[i]["data"]["txn_amt"]

          ob["chart_of_account"] =
            all_account_lines[i]["data"]["chart_of_account"];
          ob["db_cd_ind"] =
            all_account_lines[i]["data"]["db_cd_ind"];
          ob["ar_actvty_tcd"] = "MANUAL_JRNL";
          ob["jrnl_dtl_ln_id"] =
            all_account_lines[i]["data"]["jrnl_dtl_ln_id"];
          ob["jrnl_desc"] = " By " + this.ChartOfAccountObj[all_account_lines[i]["data"]["chart_of_account"]];
          ob["org_unit_cd"] = this.b_acct_id;
          ob["tgt_curr_cd"] = "INR";
          ob["jrnl_ln_id"] = "_" + i;
          ob["fin_year"] = this.fin_year;
          ob["ev_cts"] = this.current_date;
          ob["ld_fm"] = month + 1;
          ob["acct_dt"] = all_account_lines[i]['data']["acct_dt"];

          ob["ledger_type"] = "ACT";
          ob["prep_id"] = all_account_lines[i]["data"]["prep_id"];
          ob["appr_id"] = this.erpUser.user_id;
          ob["ar_actvty_lcl_num"] = manual_jrnl['data'][0]['id']
          ob["ar_src_cd"] = "ACCOUNT";
          ob["cp_bnk_acct_id"] = all_account_lines[i]["data"]["cp_bnk_acct_id"]
          ob["event_code"] = all_account_lines[i]["data"]["event_code"];
          ob["ld_jrnl_ref_num"] = "ACCOUNT-MANUAL_JOURNAL-" + manual_jrnl['data'][0]["jrnl_id"];
          ob["ld_jrnl_lfcycl_st_cd"] = "POSTED";
          ob["ld_jrnl_unpost_seq_num"] = 0;
          ob["ld_acct_per"] = 0;
          ob["ld_cat_cd"] = "FIN";
          ob["ld_jrnl_rvrsl_tcd"] = manual_jrnl['data'][0]['preparer_comment'];
          ob["ld_tgt_cur_tcd"] = "FN";
          ob["ld_jrnl_entry_cd"] = "Auto";
          ob["ld_jrnl_ln_ksn"] = manual_jrnl['data'][0]["jrnl_id"] + "-" + all_account_lines[i]["data"]["db_cd_ind"];
          ob["ld_jrnl_ln_desc"] = manual_jrnl['data'][0]['preparer_comment']//"ACCOUNT" + "-MANUAL JURNAL-" + manual_jrnl['data'][0]["jrnl_id"] + "-" + all_account_lines[i]["data"]["ar_cntr_ip_name"];
          ob["ld_src_cd"] = "ACCOUNT";
          ob["ld_tech_comp_cd"] = "ARE";
          ob["ld_jrnl_dtln_desc"] =
            "ACCOUNT" +
            "-MANUAL JURNAL-" +
            manual_jrnl['data'][0]["jrnl_id"]


          ob["ld_bus_func_cd"] = "MAUAL_JOURNAL2JV";
          ob["ld_unadj_acct_dt"] = this.current_date;
          ob["pmt_bnk_acct_id"] = all_account_lines[i]["data"]["proj_cd"]
          ob["ld_aff_cc_cd"] = this.prohierObj[all_account_lines[i]["data"]["proj_cd"]]
          ob["ld_cc_cd"] = 0;
          ob["ld_jrnl_dtl_ln_ksn"] = "_" + i + "_" + i;
          data.push(ob);
        }
        if (all_account_lines[i]["type"] == "debit") {
          let ob: any = new Object();
          ob["ld_prj_cd"] = all_account_lines[i]['data']["proj_cd"];
          ob["ld_act_cd"] = all_account_lines[i]['data']["act_cd"];
          ob["ld_pd_cd"] = all_account_lines[i]['data']["prod_cd"];
          ob["ld_bugt_cd"] = all_account_lines[i]['data']["bud_cd"];
          ob["txn_amt"] =
            (-1 * all_account_lines[i]["data"]["txn_amt"]);
          ob["ar_actvty_tcd"] = "MANUAL_JRNL";
          ob["db_cd_ind"] = all_account_lines[i]["data"]["db_cd_ind"];
          ob["chart_of_account"] = all_account_lines[i]["data"]["chart_of_account"];
          ob["arr_id"] = manual_jrnl['data'][0]["jrnl_id"];
          ob["event_code"] = all_account_lines[i]["data"]["event_code"];
          ob["jrnl_dtl_ln_id"] = all_account_lines[i]["data"]["jrnl_dtl_ln_id"];
          ob["org_unit_cd"] = this.b_acct_id;
          ob["tgt_curr_cd"] = "INR";
          ob["jrnl_ln_id"] = all_account_lines[i]["data"]["jrnl_ln_id"];
          ob["fin_year"] = this.fin_year;
          ob["ev_cts"] = this.current_date;
          ob["ld_fm"] = month + 1;
          ob["acct_dt"] = all_account_lines[i]["data"]["acct_dt"];
          ob["jrnl_desc"] = " To " + this.ChartOfAccountObj[all_account_lines[i]["data"]["chart_of_account"]];
          ob["ledger_type"] = "ACT";
          ob["prep_id"] = all_account_lines[i]["data"]["prep_id"];
          ob["appr_id"] = this.erpUser.user_id;
          ob["ar_actvty_lcl_num"] = manual_jrnl['data'][0]['id']
          ob["ar_src_cd"] = "ACCOUNT";
          ob["ar_cntr_ip_id"] = all_account_lines[i]["data"]["ar_cntr_ip_id"];
          ob["ar_cntr_ip_name"] = all_account_lines[i]["data"]["ar_cntr_ip_id"] === 420 ? 'BENEFICIARY' : all_account_lines[i]["data"]["ar_cntr_ip_name"];//all_account_lines[i]["data"]["ar_cntr_ip_name"];
          // ob["event_id"] = all_account_lines[i]["data"]["event_id"];
          ob["event_id"] = manual_jrnl['data'][0]['id'];
          ob["cp_bnk_acct_id"] = all_account_lines[i]["data"]["cp_bnk_acct_id"]
          ob["ld_jrnl_ref_num"] = "ACCOUNT-MANUAL_JOURNAL-" + manual_jrnl['data'][0]["jrnl_id"];
          ob["ld_jrnl_lfcycl_st_cd"] = "POSTED";
          ob["ld_jrnl_unpost_seq_num"] = 0;
          ob["ld_acct_per"] = 0;
          ob["ld_cat_cd"] = "FIN";
          ob["ld_jrnl_rvrsl_tcd"] = manual_jrnl['data'][0]['preparer_comment'];
          ob["ld_tgt_cur_tcd"] = "FN";
          ob["ld_jrnl_entry_cd"] = "Auto";
          ob["ld_jrnl_ln_ksn"] = manual_jrnl['data'][0]["jrnl_id"] + "-" + all_account_lines[i]["data"]["db_cd_ind"];
          ob["ld_jrnl_ln_desc"] = manual_jrnl['data'][0]['preparer_comment'];//"ACCOUNT" + "-MANUAL JURNAL-" + manual_jrnl['data'][0]["jrnl_id"] + "-" + all_account_lines[i]["data"]["ar_cntr_ip_name"];
          ob["ld_src_cd"] = "ACCOUNT";
          ob["ld_tech_comp_cd"] = "ARE";
          ob["ld_jrnl_dtln_desc"] = "ACCOUNT" + "-MANUAL JURNAL-" + manual_jrnl['data'][0]["jrnl_id"];
          ob["ld_bus_func_cd"] = "MAUAL_JOURNAL2JV";
          ob["ld_unadj_acct_dt"] = this.current_date;
          ob["pmt_bnk_acct_id"] = 0;
          ob["ld_aff_cc_cd"] = this.prohierObj[all_account_lines[i]["data"]["proj_cd"]]
          ob["ld_cc_cd"] = all_account_lines[i]["data"]["proj_cd"]
          ob["ld_jrnl_dtl_ln_ksn"] = "_" + i + "_" + i;
          data.push(ob);
        }
      }
      let obj: any = new Object();
      obj["b_acct_id"] = this.b_acct_id;
      obj["data"] = data;
      obj['budget'] = bud_obj['data'];
      obj['actul_bud'] = bud_obj['actul_bud'];
      obj['fin_year'] = this.fin_year;
      obj["status"] = "POSTED";
      // this.spinner.hide()
      let resp = await this.ledgerService.postingJournal(obj);
      if (resp["error"] == false) {
        this.spinner.hide();
        // await this.getAllManualJournalInfo();
        // Swal.fire("SUCCESS", "Journal Posted Successfully!", "success");
        return true;
      } else {
        this.spinner.hide();
        Swal.fire("ERROR", "Error While Posting Manual Journal", "error");
        return false
      }
    } else {

      return false;
    }

  }


  /************************************Posting of manual journla END ***************************************************** */


  /************************************** Posting of Department Bill Document Start ************************************************************** */

  async processDepartmentBill(element: any) {
    this.spinner.show();
    let obj: any = Object.assign({}, {});

    obj['b_acct_id'] = this.b_acct_id
    obj['event_group_id'] = [element['doc_local_no']]
    obj['id'] = element.doc_local_no
    await this.FinYear();
    let event_group_data = await this.eventGroupService.geteventByID(JSON.stringify(obj));

    if (event_group_data['error'] == false) {
      let resp = await this.eventGroupService.geteventxref(JSON.stringify(obj));
      // let event_group_id = element['id'];
      let eventdata = []
      eventdata = resp['data'];
      let processed_data = await this.ruleProcessingNewService.startProcessing(eventdata);
      let bud_obj = await this.budgetEffectService.getBudgetObj(eventdata, this.b_acct_id, event_group_data.data[0].total_amt);
      if (bud_obj['error'] === true) {
        this.spinner.hide();
        Swal.fire("Error", bud_obj['data'], 'error');
        return false;
      }
      if (processed_data['error'] == true) {
        this.spinner.hide();
        Swal.fire("Error", processed_data['data'], 'error');
        return false;
      }
      if (processed_data['data'].length > 0) {
        let obj1 = Object.assign({}, element);
        obj1['b_acct_id'] = this.b_acct_id;
        obj1['status'] = 'PROCESSED';
        obj1['update_user_id'] = this.erpUser.user_id;
        obj1['jrnl'] = processed_data['data'];
        obj1['budget'] = bud_obj['data'];
        obj1['actul_bud'] = bud_obj['actul_bud'];
        obj1['fin_year'] = this.fin_year;
        let resp = await this.eventGroupService.insertProcessedData(obj1);
        if (resp['error'] == false) {
          this.spinner.hide();

          return true;
        } else {

          this.spinner.hide();
          Swal.fire("Error", "...Error while Processed  Bill Insert!", 'error');
          return false;
        }
      } else {
        this.spinner.hide();
        Swal.fire("Error", "...Some Events does not have rule  !", 'error');
        return false
      }
    } else {

      this.spinner.hide();
      Swal.fire("Error", "...Some Error Occured While Processing", 'error');
      return false
    }
  }



  async createJVFromCBBill(element: any) {
    this.spinner.show();
    let obj: any = Object.assign({}, {});
    let returnObj: any = {}

    obj['b_acct_id'] = this.b_acct_id
    obj['event_group_id'] = [element['doc_local_no']]
    obj['id'] = element.doc_local_no
    await this.FinYear();
    // let event_group_data = await this.eventGroupService.geteventByID(JSON.stringify(obj));

    // if (event_group_data['error'] == false) {
      // let resp = await this.eventGroupService.geteventxref(JSON.stringify(obj));
      // let event_group_id = element['id'];
      // let eventdata = []
      const event_data = element.event_data.map((x: any) => {
        return { ...x, ev_grp_tcd: 'CB_BILL' };
      });
      let eventdata = event_data;
      let processed_data = await this.ruleProcessingNewService.startProcessing(eventdata);
      let bud_obj = await this.budgetEffectService.getBudgetObj(element.event_data, this.b_acct_id, element.totatl_amount);
      if (bud_obj['error'] === true) {
        this.spinner.hide();
        Swal.fire("Error", bud_obj['data'], 'error');
        returnObj['error'] = true;
        return returnObj;
      }
      if (processed_data['error'] == true) {
        this.spinner.hide();
        Swal.fire("Error", processed_data['data'], 'error');
        returnObj['error'] = true;
        return returnObj;
      }
      if (processed_data['data'].length > 0) {
        let obj1 = Object.assign({}, element);
        obj1['b_acct_id'] = this.b_acct_id;
        obj1['status'] = 'PROCESSED';
        obj1['update_user_id'] = this.erpUser.user_id;
        obj1['jrnl'] = processed_data['data'];
        obj1['budget'] = bud_obj['data'];
        obj1['actul_bud'] = bud_obj['actul_bud'];
        obj1['fin_year'] = this.fin_year;
        // let resp = await this.eventGroupService.insertProcessedData(obj1);
        // if (resp['error'] == false) {
        //   this.spinner.hide();

        //   return true;
        // } else {

        //   this.spinner.hide();
        //   Swal.fire("Error", "...Error while Processed  Bill Insert!", 'error');
        //   return false;
        // }

        returnObj['error'] = false
        returnObj['data'] = obj1

        return returnObj
      } else {
        this.spinner.hide();
        Swal.fire("Error", "...Some Events does not have rule  !", 'error');
        returnObj['error'] = true
        returnObj['data'] = "Error"
        return returnObj
      }
    // } else {

    //   this.spinner.hide();
    //   Swal.fire("Error", "...Some Error Occured While Processing", 'error');
    //   returnObj['error'] = true
    //   returnObj['data'] = "Error"
    //   return returnObj
    // }
  }





  /************************************** Posting of Department Bill Document Start ************************************************************** */




  /**************************************Posting of BP Start ************************************************************** */
  // async postBankPayment(bp_ids) {
  //   const ststem_date = await this.billService.getSystemDate();
  //   let systemDate = ststem_date['data'];
  //   await this.getChartOfAccount()
  //   await this.FinYear()
  //   let obj = {};
  //   obj['b_acct_id'] = this.erpUser.b_acct_id
  //   obj['bp_id'] = bp_ids
  //   let resp = await this.BPS.getList(JSON.stringify(obj));
  //   if (resp['error'] == false) {
  //     let bank_paymnet_data = resp['data']
  //     let arr1 = []

  //     bank_paymnet_data.map(async (x, i) => {
  //       let event = JSON.parse(x['data'])
  //       let ob_db = new Object();
  //       ob_db = {
  //         "arr_id": event['arr_id'],
  //         "acct_dt": event['bp_date'],
  //         "appr_id": this.erpUser.user_id,
  //         "ar_src_cd": "ACCOUNT",
  //         "ar_num_in_src": null,
  //         "ar_actvty_tcd": "BP",
  //         "ar_actvty_lcl_num": event['ev_grp_lcl_unq_num_in_src'],
  //         "ar_instr_cd": event['email'],
  //         "ar_cntr_ip_id": event['party_id'],
  //         "ar_cntr_ip_name": event['party_leagal_name'],
  //         "create_timestamp": systemDate,
  //         "chart_of_account": x['chart_of_account'],
  //         "cp_bnk_acct_id": 0,
  //         "db_cd_ind": "DB",
  //         "event_code": event['event_code'],
  //         "event_id": x.id,
  //         "ev_cts": x['bp_date'],
  //         "fin_year": this.fin_year,
  //         "jrnl_dtl_ln_id": "1",
  //         "jrnl_ln_id": 1,
  //         "jrnl_id": event['jrnl_id'],
  //         "jrnl_desc": 'To ' + this.ChartOfAccountObj[event['bank_chart_of_account']],
  //         "ledger_type": "ACT",
  //         "ld_jrnl_ref_num": event['ld_jrnl_ref_num'],
  //         // "ld_jrnl_lfcycl_st_cd": "PROCESSED",
  //         "ld_jrnl_lfcycl_st_cd": "POSTED",
  //         "ld_jrnl_unpost_seq_num": 0,
  //         "ld_fm": 11,
  //         "ld_acct_per": 328,
  //         "ld_cat_cd": "FIN",
  //         "ld_jrnl_entry_cd": "Auto",
  //         "ld_tgt_cur_tcd": "FN",
  //         "ld_jrnl_rvrsl_tcd": event['ld_jrnl_rvrsl_tcd'],
  //         "ld_jrnl_rvrsl_dt": null,
  //         "ld_parent_jrnl_id": null,
  //         "ld_jrnl_ln_ksn": event['jrnl_id'] + "-DB",
  //         "ld_jrnl_ln_desc": event['ld_jrnl_ln_desc'],//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  //         "ld_bk_cd": null,
  //         "ld_src_cd": "ACCOUNT",
  //         "ld_pd_cd": event['ld_pd_cd'],
  //         "ld_prj_cd": event['ld_prj_cd'],
  //         "ld_jrnl_dtl_ln_ksn": "_" + 1 + "_0",
  //         "ld_tech_comp_cd": "ARE",
  //         "ld_jrnl_dtln_desc": event['jrnl_desc'],
  //         "ld_bus_func_cd": "JV2BP",
  //         "ld_unadj_acct_dt": systemDate,
  //         "org_unit_cd": this.b_acct_id,
  //         "proc_dt": null,
  //         "prep_id": this.erpUser.user_id,
  //         "pmt_bnk_acct_id": 0,
  //         "tgt_curr_cd": "INR",
  //         "txn_amt": (-1) * event['txn_amt'],
  //         "ld_cc_cd": event['ld_cc_cd'],
  //         "ld_aff_cc_cd": event['ld_aff_cc_cd'],
  //         "ld_bugt_cd": event['ld_bugt_cd'],
  //         "ld_act_cd": event['ld_act_cd']
  //       }

  //       let ob_cr = new Object();
  //       ob_cr = {
  //         "arr_id": event['arr_id'],
  //         "acct_dt": event['bp_date'],
  //         "appr_id": this.erpUser.user_id,
  //         "ar_src_cd": "ACCOUNT",
  //         "ar_num_in_src": null,
  //         "ar_actvty_tcd": "BP",
  //         "ar_actvty_lcl_num": event['ev_grp_lcl_unq_num_in_src'],
  //         "ar_instr_cd": event['email'],
  //         "ar_cntr_ip_id": event['party_id'],
  //         "ar_cntr_ip_name": event['party_leagal_name'],
  //         "create_timestamp": systemDate,
  //         "chart_of_account": event['bank_chart_of_account'],
  //         // "cp_bnk_acct_id": event['org_bank_acct_no'],
  //         "cp_bnk_acct_id": event['relation'],
  //         "db_cd_ind": "CR",
  //         "event_code": event['event_code'],
  //         "event_id": x.id,
  //         "ev_cts": event['bp_date'],
  //         "fin_year": this.fin_year,
  //         "jrnl_dtl_ln_id": "1",
  //         "jrnl_ln_id": 1,
  //         "jrnl_id": event['jrnl_id'],
  //         "jrnl_desc": 'By ' + this.ChartOfAccountObj[event['bank_chart_of_account']],
  //         "ledger_type": "ACT",
  //         "ld_jrnl_ref_num": event['ld_jrnl_ref_num'],
  //         "ld_jrnl_lfcycl_st_cd": "POSTED",
  //         "ld_jrnl_unpost_seq_num": 0,
  //         "ld_fm": 11,
  //         "ld_acct_per": 328,
  //         "ld_cat_cd": "FIN",
  //         "ld_jrnl_entry_cd": "Auto",
  //         "ld_tgt_cur_tcd": "FN",
  //         "ld_jrnl_rvrsl_tcd": event['ld_jrnl_rvrsl_tcd'],
  //         "ld_jrnl_rvrsl_dt": null,
  //         "ld_parent_jrnl_id": null,
  //         "ld_jrnl_ln_ksn": event['jrnl_id'] + "-CR",
  //         "ld_jrnl_ln_desc": event['ld_jrnl_ln_desc'],
  //         "ld_bk_cd": null,
  //         "ld_src_cd": "ACCOUNT",
  //         "ld_pd_cd": event['ld_pd_cd'],
  //         "ld_prj_cd": event['ld_prj_cd'],
  //         "ld_jrnl_dtl_ln_ksn": "_" + 1 + "_0",
  //         "ld_tech_comp_cd": "ARE",
  //         "ld_jrnl_dtln_desc": event['ld_jrnl_ln_desc'],
  //         "ld_bus_func_cd": "JV2BP",
  //         "ld_unadj_acct_dt": systemDate,
  //         "org_unit_cd": this.b_acct_id,
  //         "proc_dt": null,
  //         "prep_id": this.erpUser.user_id,
  //         "pmt_bnk_acct_id": 0,
  //         "tgt_curr_cd": "INR",
  //         "txn_amt": event['txn_amt'],
  //         "ld_cc_cd": event['ld_cc_cd'],
  //         "ld_aff_cc_cd": event['ld_aff_cc_cd'],
  //         "ld_bugt_cd": event['ld_bugt_cd'],
  //         "ld_act_cd": event['ld_act_cd']
  //       }
  //       arr1.push(ob_cr, ob_db)
  //     })

  //     let obj1 = {}
  //     obj1['b_acct_id'] = this.b_acct_id;
  //     obj1['jrnl'] = arr1;
  //     console.log(obj1);

  //     let resp2 = await this.BPS.insertProcessedbp(obj1);
  //     if (resp2['error'] == false) {
  //       this.spinner.hide();
  //       // Swal.fire("Success", "Processed Successfully!", 'success');
  //       return { error: false }
  //     } else {
  //       this.spinner.hide();
  //       Swal.fire("Error", "...Error while Processed  !", 'error');
  //       return { error: true }
  //     }

  //   } else {
  //     Swal.fire("ERROR", "Error While Posting Bank Payment", "error");
  //   }
  // }
  async changeBPSatusInBPandJV(bp_ids: any) {
    let obj: any = new Object();
    obj["b_acct_id"] = this.b_acct_id;
    obj['bp_ids'] = bp_ids;
    let resp = await this.BPS.changeBPSatusInBPandJV(obj);
    if (resp["error"] == false) {
      // Swal.fire("SUCCESS",'Bank Payment Posted','success');
      return { error: false }
    } else {
      Swal.fire("ERROR", "Error while posting Bank Boucher", "error");
      return { error: true }
    }
  }
  /**************************************Posting of BP End ************************************************************** */


  /********************************************* CROSS MODULE Start ********************************************************* */
  async crossModuleRejection(element: any) {
    // console.log(element);
    // let obj = Object.assign({}, {});
    // obj['b_acct_id'] = this.b_acct_id
    // obj['doc_local_no'] = element['doc_local_no']
    // obj['doc_type'] = element.doc_type
    // obj['module_cd'] = element.module_cd
    // obj['id'] = element.id

    this.spinner.show()
    return await this.eventGroupService.crossModuleRejection({ ...element, b_acct_id: this.b_acct_id });
    // if (resp['error'] == false) {


    //   return resp
    //   // this.spinner.hide()
    // } else {



    //   return resp
    //   // Swal.fire('ERROR','Error While Rejecting Bill','error')
    //   // this.spinner.hide();
    // }





  }
  /********************************************* CROSS MODULE End ********************************************************* */


  /**************************************Accepting Bill Start ************************************************************ */
  allCBInfo: any = []
  allCbObj: any = {}
  projectLeafUserObj: any = {}
  async getAllCBInfo() {
    var resp = await this.billService.getAllContingentBills(this.b_acct_id);
    if (resp["error"] == false) {
      this.allCBInfo = resp.data;
      resp.data.map((x: any) => {
        this.allCbObj[x['cb_id']] = x
      })
    } else {
      this.spinner.hide();
      // Swal.fire("Error", "..Error while getting  all CB list!", "error");
    }
  }
  budgetObj: any = {};
  hierobj: any = { budget: {}, activity: {}, product: {}, project: {} };






  async getAllBudget() {
    // this.spinner.show();
    var obj: any = new Object();
    obj["b_acct_id"] = this.b_acct_id
    obj["table_name"] = "bud_hier";
    var resp = await this.hierarchyService.getBudgetHierarchy(obj);
    if (resp["error"] == false) {
      // this.log.createLog({ ...this.logObj, activity: 'GET', message: "BUDGET-HIERARCHY LIST RECEIVED SUCCESSFULLY" })
      this.spinner.hide();
      // this.allBudgetHier = resp.data;

      // for (let i = 0; i < this.allBudgetHier.length; i++) {
      // console.log(this.allBudgetHier[i]);
      // let str = "";
      // for (let j = 1; j < 8; j++) {
      //   if (
      //     this.allBudgetHier[i]["lvl" + j + "_cd"] != null &&
      //     this.allBudgetHier[i]["lvl" + j + "_cd"] != ""
      //   ) {
      //     str += this.allBudgetHier[i]["lvl" + j + "_value"] + " > ";
      //   }
      // }

      // str = str.substring(0, str.length - 2);
      // this.allBudgetHier[i]["desc"] = str;
      // this.budgetObj[this.allBudgetHier[i]["leaf_cd"]] = str;
      //   this.hierobj["budget"][this.allBudgetHier[i]["leaf_cd"]] =
      //     this.allBudgetHier[i];
      // }

      resp.data.map((x: any) => {
        this.hierobj["budget"][x["leaf_cd"]] = x
        this.budgetObj[x["leaf_cd"]] = x['leaf_value']
      })

    } else {
      this.spinner.hide();
    }
  }

  activityObj: any = {};
  async getAllActivity() {
    var obj: any = new Object();
    obj["b_acct_id"] = this.b_acct_id
    obj["table_name"] = "activity_hier";
    var resp = await this.hierarchyService.getActivityHierarchy(obj);
    if (resp["error"] == false) {
      // this.log.createLog({ ...this.logObj, activity: 'GET', message: "ACTIVITY-HIERARCHY LIST RECEIVED SUCCESSFULLY" })
      // this.allActivityHier = resp.data;
      // for (let i = 0; i < this.allActivityHier.length; i++) {
      //   // console.log(this.allActivityHier[i]);
      //   let str: any = "";
      //   for (let j = 1; j < 8; j++) {
      //     if (
      //       this.allActivityHier[i]["lvl" + j + "_cd"] != null &&
      //       this.allActivityHier[i]["lvl" + j + "_cd"] != ""
      //     ) {
      //       str += this.allActivityHier[i]["lvl" + j + "_value"] + " > ";
      //     }
      //   }

      //   str = str.substring(0, str.length - 2);
      //   this.allActivityHier[i]["desc"] = str;
      //   this.activityObj[this.allActivityHier[i]["leaf_cd"]] = str;
      //   this.hierobj["activity"][this.allActivityHier[i]["leaf_cd"]] =
      //     this.allActivityHier[i];
      // }

      resp.data.map((x: any) => {
        this.hierobj["activity"][x["leaf_cd"]] = x
        this.activityObj[x["leaf_cd"]] = x['leaf_value']
      })

    } else {
    }
  }



  productObj: any = {};
  async getAllProduct() {
    var obj: any = new Object();
    obj["b_acct_id"] = this.b_acct_id
    obj["table_name"] = "prod_hier";
    var resp = await this.hierarchyService.getProductHierarchy(obj);
    if (resp["error"] == false) {
      // this.log.createLog({ ...this.logObj, activity: 'GET', message: "PRODUCT-HIERARCHY LIST RECEIVED SUCCESSFULLY" })
      // this.allProductHier = resp.data;
      // for (let i = 0; i < this.allProductHier.length; i++) {
      //   let str: any = "";
      //   for (let j = 1; j < 8; j++) {
      //     if (
      //       this.allProductHier[i]["lvl" + j + "_cd"] != null &&
      //       this.allProductHier[i]["lvl" + j + "_cd"] != ""
      //     ) {
      //       str += this.allProductHier[i]["lvl" + j + "_value"] + " > ";
      //     }
      //   }

      //   str = str.substring(0, str.length - 2);
      //   this.allProductHier[i]["desc"] = str;
      //   this.productObj[this.allProductHier[i]["leaf_cd"]] = str;
      //   this.hierobj["product"][this.allProductHier[i]["leaf_cd"]] =
      //     this.allProductHier[i];
      // }
      resp.data.map((x: any) => {
        this.hierobj["product"][x["leaf_cd"]] = x
        this.productObj[x["leaf_cd"]] = x['leaf_value']

      })

    } else {
    }
  }


  dedtoActivity: any = {};
  dedtoBudeget: any = {};
  async getDedData() {
    var resp = await this.settingService.getDeductionMappingList(this.b_acct_id);
    if (resp["error"] == false) {
      let allDeduction = resp.data;

      for (let j = 0; j < allDeduction.length; j++) {
        this.dedtoActivity[allDeduction[j]["ded_code"] + allDeduction[j]["gov_rule"]] = allDeduction[j]["act_cd"];
        this.dedtoBudeget[allDeduction[j]["ded_code"] + allDeduction[j]["gov_rule"]] = allDeduction[j]["bud_cd"];
      }

      // this.spinner.hide()
    } else {
      this.spinner.hide()
      Swal.fire("Error", "...Error while getting list!", "error");
    }
  }
  postpixAdd(i: any) {
    var j = i % 10,
      k = i % 100;
    if (j == 1 && k != 11) {
      return i + "st";
    }
    if (j == 2 && k != 12) {
      return i + "nd";
    }
    if (j == 3 && k != 13) {
      return i + "rd";
    }
    return i + "th";
  }
  rateObj: any = {}
  async getgst() {
    var resp = await this.billService.getgst(this.b_acct_id);
    if (resp["error"] == false) {

      let hsnArr = resp.data;
      // this.gstObj = new Object();
      // this.hsnObj = new Object();
      this.rateObj = new Object();
      for (let i = 0; i < hsnArr.length; i++) {
        // this.gstObj[this.hsnArr[i]["hsn_code"]] = this.hsnArr[i];
        // this.hsnObj[this.hsnArr[i]["hsn_code"]] = this.hsnArr[i]["hsn_desc"];
        this.rateObj[hsnArr[i]["hsn_code"]] = hsnArr[i]["igst"];
      }
      // console.log(this.rateObj);
    } else {
      Swal.fire("Error", "..Error while getting GST!", "error");
    }
  }


  countBill(element: any) {
    let count = 1;
    this.allCBInfo.map((x: any) => {
      if (element['work_id'] == x['work_id'] && x['status'] == 'APPROVED') {
        count++;
      }
    })
    return count;
  }


  async changeGst(i: any) {
    this.AllBillRow[i]["cgst"] = 0;
    this.AllBillRow[i]["sgst"] = 0;
    this.AllBillRow[i]["igst"] = 0;
    if (this.AllBillRow[i]["gst_type"] == "cgst_sgst") {
      let amt = 0;
      amt =
        (this.AllBillRow[i]["amount"] *
          this.rateObj[this.AllBillRow[i]["hsn_code"]]) /
        100;

      this.AllBillRow[i]["cgst"] = parseFloat((amt / 2).toFixed(2));
      this.AllBillRow[i]["sgst"] = parseFloat((amt / 2).toFixed(2));
    }

    if (this.AllBillRow[i]["gst_type"] == "igst") {
      let amt = 0;
      amt =
        (this.AllBillRow[i]["amount"] *
          this.rateObj[this.AllBillRow[i]["hsn_code"]]) /
        100;

      this.AllBillRow[i]["igst"] = parseFloat(amt.toFixed(2));
    }

    let tax_amount =
      this.AllBillRow[i]["cgst"] +
      this.AllBillRow[i]["sgst"] +
      this.AllBillRow[i]["igst"];

    this.AllBillRow[i]["tax_amount"] = parseFloat(tax_amount.toFixed(2));
    this.AllBillRow[i]["total_amount"] =
      this.AllBillRow[i]["amount"] + parseFloat(tax_amount.toFixed(2));
  }






  totalAmount: number = 0;
  net_amount: number = 0;
  cgstAmount: number = 0;
  sgstAmount: number = 0;
  igstAmount: number = 0;
  total_ded_amount: number = 0;
  total_amt: number = 0;
  AllDedRow: any = []
  AllBillRow: any = []
  async check() {
    // await this.allAllocation()
    var total1: number = 0;
    this.cgstAmount = 0;
    this.sgstAmount = 0;
    this.igstAmount = 0;
    this.totalAmount = 0;
    this.net_amount = 0;
    // this.total_amt=0
    let obj: any = new Object();
    let obj_ded_rule: any = new Object();
    this.total_ded_amount = 0;
    this.AllDedRow = [];


    let tot_bill_amt: any = 0;



    // // var total1 = 0;
    // var cgstAmount = 0;
    // var sgstAmount = 0;
    // var igstAmount = 0;
    // var totalAmount = 0;
    // this.net_amount = 0;
    // let obj = new Object();
    // let obj_ded_rule = new Object();
    // this.total_ded_amount = 0;
    // this.AllDedRow = [];


    // let tot_bill_amt = 0;











    this.AllBillRow.map((x: any) => {
      tot_bill_amt += x['amount']
    })





    for (let i = 0; i < this.AllBillRow.length; i++) {
      await this.changeGst(i);
      let totalDed: any = 0;
      this.cgstAmount = this.cgstAmount + this.AllBillRow[i]["cgst"];
      this.sgstAmount = this.sgstAmount + this.AllBillRow[i]["sgst"];
      this.igstAmount = this.igstAmount + this.AllBillRow[i]["igst"];
      let tax_amount: any = this.AllBillRow[i]["cgst"] + this.AllBillRow[i]["sgst"] + this.AllBillRow[i]["igst"];

      this.AllBillRow[i]["tax_amount"] = parseFloat(tax_amount.toFixed(2));
      this.AllBillRow[i]["payable_amount"] = this.AllBillRow[i]["amount"] + parseFloat(tax_amount.toFixed(2));
      this.AllBillRow[i]["total_amount"] = this.AllBillRow[i]["amount"] + parseFloat(tax_amount.toFixed(2));


      for (let j = 0; j < this.AllBillRow[i]["ded"].length; j++) {
        if (obj[this.AllBillRow[i]["ded"][j]["deduction_type"]] == undefined) {
          obj[this.AllBillRow[i]["ded"][j]["deduction_type"]] = 0;
        }
        if (obj_ded_rule[this.AllBillRow[i]["ded"][j]["deduction_type"]] == undefined) {
          obj_ded_rule[this.AllBillRow[i]["ded"][j]["deduction_type"]] = "";
        }
        obj_ded_rule[this.AllBillRow[i]["ded"][j]["deduction_type"]] = obj_ded_rule[this.AllBillRow[i]["ded"][j]["deduction_type"]] +
          "@" + this.AllBillRow[i]["ded"][j]["gov_rule"];

        if (this.AllBillRow[i]["ded"][j]["amt_type"] == "percentage") {
          // totalDed = totalDed + (this.AllBillRow[i]["amount"] * this.AllBillRow[i]["ded"][j]["ded_amount"]) / 100;
          totalDed = totalDed + (tot_bill_amt * this.AllBillRow[i]["ded"][j]["ded_amount"]) / 100;
          // obj[this.AllBillRow[i]["ded"][j]["deduction_type"]] = obj[this.AllBillRow[i]["ded"][j]["deduction_type"]] +
          //   (this.AllBillRow[i]["amount"] * this.AllBillRow[i]["ded"][j]["ded_amount"]) / 100;

          this.AllDedRow.push({
            deduction_type: this.AllBillRow[0]["ded"][j]["deduction_type"],
            // ded_amount: (this.AllBillRow[0]["amount"] * this.AllBillRow[0]["ded"][j]["ded_amount"]) / 100,
            ded_amount: (tot_bill_amt * this.AllBillRow[0]["ded"][j]["ded_amount"]) / 100,
            gov_rule: this.AllBillRow[0]["ded"][j]["gov_rule"],
          });

        } else {
          totalDed = totalDed + this.AllBillRow[0]["ded"][j]["ded_amount"];
          // obj[this.AllBillRow[i]["ded"][j]["deduction_type"]] =
          //   obj[this.AllBillRow[i]["ded"][j]["deduction_type"]] +
          //   this.AllBillRow[i]["ded"][j]["ded_amount"];


          this.AllDedRow.push({
            deduction_type: this.AllBillRow[i]["ded"][j]["deduction_type"],
            ded_amount: this.AllBillRow[i]["ded"][j]["ded_amount"],
            gov_rule: this.AllBillRow[i]["ded"][j]["gov_rule"],
          });
        }

        // this.AllDedRow.push({
        //   deduction_type: this.AllBillRow[i]["ded"][j]["deduction_type"],
        //   ded_amount: (this.AllBillRow[i]["amount"] * this.AllBillRow[i]["ded"][j]["ded_amount"]) / 100,
        //   gov_rule: this.AllBillRow[i]["ded"][j]["gov_rule"],
        // });
        // this.total_ded_amount = this.total_ded_amount + (this.AllBillRow[i]["amount"] * this.AllBillRow[i]["ded"][j]["ded_amount"]) / 100
      }


      this.total_ded_amount += totalDed;
      this.AllBillRow[i]["payable_amount"] = this.AllBillRow[i]["payable_amount"] - totalDed;
      this.AllBillRow[i]["deduction_amount"] = totalDed;
      this.net_amount = this.net_amount + this.AllBillRow[i]["payable_amount"];
      // total1 = total1 + this.AllBillRow[i]["amount"] + this.AllBillRow[i]["tax_amount"];
      total1 = total1 + tot_bill_amt + this.AllBillRow[i]["tax_amount"];
      this.totalAmount = this.totalAmount + this.AllBillRow[i]["amount"];
    }
    this.total_amt = parseFloat(total1.toFixed(2));
    this.totalAmount = parseFloat(this.totalAmount.toFixed(2));
    this.cgstAmount = parseFloat(this.cgstAmount.toFixed(2));
    this.sgstAmount = parseFloat(this.sgstAmount.toFixed(2));
    this.igstAmount = parseFloat(this.igstAmount.toFixed(2));

    // var keys = Object.keys(obj);
    // this.total_ded_amount = 0;
    // this.AllDedRow = [];
    // for (let i = 0; i < keys.length; i++) {
    //   this.AllDedRow.push({
    //     deduction_type: keys[i],
    //     ded_amount: obj[keys[i]],
    //     gov_rule: obj_ded_rule[keys[i]],
    //   });
    //   this.total_ded_amount = this.total_ded_amount + obj[keys[i]];
    // }
    // let flag = await this.checkBudgetAmount()
    return true;
  }

  async accptedCB(element: any) {
    await this.getDedData()
    await this.getAllCBInfo();
    await this.getAllProject();
    await this.getAllProduct();
    await this.getAllActivity();
    await this.getAllBudget();
    await this.getgst();
    // await this.getAccountProjectHierarchy();
    this.spinner.show()
    let current_cb: any = this.allCbObj[element.doc_local_no]
    let countBill = this.countBill(current_cb)
    let cb_id = [current_cb.cb_id];
    let event = [];
    let mainObj: any = new Object();
    mainObj["cb_id"] = current_cb.cb_id;
    mainObj["cb_date"] = current_cb.cb_date;
    mainObj["bill_date"] = current_cb.bill_date;
    mainObj["bill_no"] = current_cb.bill_no;
    mainObj["status"] = current_cb.status;
    mainObj["work_id"] = current_cb.work_id;



    let ob = JSON.parse(current_cb.data);



    // mainObj["act_cd"] = current_cb.act_cd;

    mainObj["work_desc"] = ob['work_desc'] //this.AllworkObj[this.obj["work_id"]]["work_desc"];
    mainObj["party_le_id"] = ob['party_le_id'] //this.AllworkObj[this.obj["work_id"]]["party_le_id"];
    mainObj["proj_cd"] = ob['proj_cd'] //this.AllworkObj[this.obj["work_id"]]["proj_cd"];
    mainObj["bud_cd"] = ob['bud_cd'] //this.AllworkObj[this.obj["work_id"]]["bud_cd"];
    mainObj["prod_cd"] = ob['prod_cd'] //this.AllworkObj[this.obj["work_id"]]["prod_cd"];
    mainObj["act_cd"] = ob['act_cd'] //this.AllworkObj[this.obj["work_id"]]["act_cd"];
    mainObj['party_name'] = ob['party_name']
    // console.log(obj);

    mainObj["party_phone_no"] = ob["party_phone_no"];
    mainObj["party_gstin_no"] = ob["party_gstin_no"];
    mainObj["party_email"] = ob["party_email"];


    this.AllBillRow = ob["payable_rows"];

    let selectObj: any = Object.assign({}, ob["selectObj"]);
    await this.check();

    let total_net: any = new Object();
    total_net["proj_cd"] = this.projectLeafUserObj["ACCOUNTWORK" + mainObj["work_id"]]["leaf_cd"];
    total_net["bud_cd"] = mainObj["bud_cd"];
    total_net["prod_cd"] = mainObj["prod_cd"];
    total_net["act_cd"] = mainObj["act_cd"];
    total_net["amt"] = this.totalAmount;
    total_net["net_amount"] = this.net_amount;
    total_net["gross_amount"] = this.totalAmount;
    total_net["party_id"] = mainObj["party_le_id"];
    total_net["work_id"] = mainObj["work_id"];
    total_net["bill_date"] = mainObj["bill_date"];
    total_net["cb_id"] = mainObj["cb_id"];
    total_net["event_cd"] = mainObj["cb_id"];
    total_net["event_rule"] = "NA";
    if (total_net["amt"] != 0) {
      event.push(total_net);
    }
    let total_cgst: any = new Object();
    total_cgst["proj_cd"] = this.projectLeafUserObj["ACCOUNTWORK" + mainObj["work_id"]]["leaf_cd"];
    total_cgst["bud_cd"] = this.dedtoBudeget["CGSTINPUTNA"];
    total_cgst["prod_cd"] = mainObj["prod_cd"];
    total_cgst["act_cd"] = this.dedtoActivity["CGSTINPUTNA"];
    total_cgst["amt"] = this.cgstAmount;
    total_cgst["net_amount"] = this.net_amount;
    total_cgst["gross_amount"] = this.totalAmount;
    total_cgst["party_id"] = mainObj["party_le_id"];
    total_cgst["work_id"] = mainObj["work_id"];
    total_cgst["bill_date"] = mainObj["bill_date"];

    total_cgst["cb_id"] = mainObj["cb_id"];
    total_cgst["event_cd"] = "CGSTINPUT";
    total_cgst["event_rule"] = "NA";

    if (total_cgst["amt"] != 0) {
      event.push(total_cgst);
    }

    let total_sget: any = new Object();
    total_sget["proj_cd"] = this.projectLeafUserObj["ACCOUNTWORK" + mainObj["work_id"]]["leaf_cd"];
    total_sget["bud_cd"] = this.dedtoBudeget["SGSTINPUTNA"];
    total_sget["prod_cd"] = mainObj["prod_cd"];
    total_sget["act_cd"] = this.dedtoActivity["SGSTINPUTNA"];
    total_sget["amt"] = this.sgstAmount;
    total_sget["net_amount"] = this.net_amount;
    total_sget["gross_amount"] = this.totalAmount;
    total_sget["party_id"] = mainObj["party_le_id"];
    total_sget["work_id"] = mainObj["work_id"];
    total_sget["bill_date"] = mainObj["bill_date"];

    total_sget["cb_id"] = mainObj["cb_id"];
    total_sget["event_cd"] = "SGSTINPUT";
    total_sget["event_rule"] = "NA";

    if (total_sget["amt"] != 0) {
      event.push(total_sget);
    }

    let total_igst: any = new Object();
    total_igst["proj_cd"] = this.projectLeafUserObj["ACCOUNTWORK" + mainObj["work_id"]]["leaf_cd"];
    total_igst["bud_cd"] = this.dedtoBudeget["IGSTINPUTNA"];
    total_igst["prod_cd"] = mainObj["prod_cd"];
    total_igst["act_cd"] = this.dedtoActivity["IGSTINPUTNA"];
    total_igst["amt"] = this.igstAmount;
    total_igst["net_amount"] = this.net_amount;
    total_igst["gross_amount"] = this.totalAmount;
    total_igst["party_id"] = mainObj["party_le_id"];
    total_igst["work_id"] = mainObj["work_id"];
    total_igst["bill_date"] = mainObj["bill_date"];

    total_igst["cb_id"] = mainObj["cb_id"];
    total_igst["event_cd"] = "IGSTINPUT";
    total_igst["event_rule"] = "NA";

    if (total_igst["amt"] != 0) {
      event.push(total_igst);
    }

    for (let k = 0; k < this.AllDedRow.length; k++) {
      let all_ded: any = new Object();
      all_ded["proj_cd"] = this.projectLeafUserObj["ACCOUNTWORK" + mainObj["work_id"]]["leaf_cd"];
      all_ded["bud_cd"] = this.dedtoBudeget[this.AllDedRow[k]["deduction_type"] + this.AllDedRow[k]["gov_rule"]];
      all_ded["prod_cd"] = mainObj["prod_cd"];
      all_ded["act_cd"] = this.dedtoActivity[this.AllDedRow[k]["deduction_type"] + this.AllDedRow[k]["gov_rule"]];
      all_ded["amt"] = this.AllDedRow[k]["ded_amount"];
      all_ded["net_amount"] = this.net_amount;
      all_ded["gross_amount"] = this.totalAmount;
      all_ded["party_id"] = mainObj["party_le_id"];
      all_ded["work_id"] = mainObj["work_id"];
      all_ded["bill_date"] = mainObj["bill_date"];
      all_ded["cb_id"] = mainObj["cb_id"];
      all_ded["event_cd"] = this.AllDedRow[k]["deduction_type"];
      all_ded["event_rule"] = this.AllDedRow[k]["gov_rule"];

      if (all_ded["amt"] != 0) {
        event.push(all_ded);
      }
    }

    if (event.length == 0) {
      Swal.fire("Warning", "All Event are with 0 amount...", "warning");
      return;
    }

    let event_code_data = [];
    for (let p = 0; p < event.length; p++) {

      // if (!this.hierobj["activity"][event[p]["act_cd"]] || !this.hierobj["budget"][event[p]["bud_cd"]]
      //   || !this.hierobj["product"][event[p]["prod_cd"]] || !this.hierobj["project"][event[p]["proj_cd"]]) {
      //   Swal.fire("error", 'Please Check Deduction Mapping For ' + event[p]['event_cd'], 'error');
      //   this.spinner.hide();
      //   return;
      // }

      if (this.hierobj["activity"][event[p]["act_cd"]] == undefined) {
        // Swal.fire("error", 'Please check Activity Mapping ' + event[p]["act_cd"], 'error');
        Swal.fire("error", 'Please check Deduction Mapping of ' + event[p]["event_cd"], 'error');
        this.spinner.hide();

        return;
      } else if (this.hierobj["budget"][event[p]["bud_cd"]]["leaf_value"] == undefined) {
        // Swal.fire("error", 'Please check Budget Mapping ' + event[p]["bud_cd"], 'error');
        Swal.fire("error", 'Please check Deduction Mapping of ' + event[p]["event_cd"], 'error');
        this.spinner.hide();

        return;
      } else if (this.hierobj["product"][event[p]["prod_cd"]]["leaf_value"] == undefined) {
        Swal.fire("error", 'Please check Deduction Mapping of ' + event[p]["event_cd"], 'error');
        // Swal.fire("error", 'Please check Product Mapping ' + event[p]["prod_cd"], 'error');
        this.spinner.hide();
      } else if (this.hierobj["project"][event[p]["proj_cd"]]["leaf_value"] == undefined) {
        Swal.fire("error", 'Please check Deduction Mapping of ' + event[p]["event_cd"], 'error');
        // Swal.fire("error", 'Please check Project Mapping ' + event[p]["proj_cd"], 'error');
        this.spinner.hide();
        return;
      }
      event_code_data.push({
        act_value: this.hierobj["activity"][event[p]["act_cd"]]["leaf_value"],
        bud_value: this.hierobj["budget"][event[p]["bud_cd"]]["leaf_value"],
        prod_value: this.hierobj["product"][event[p]["prod_cd"]]["leaf_value"],
        proj_value: this.hierobj["project"][event[p]["proj_cd"]]["leaf_value"],
        act_cd: event[p]["act_cd"],
        bud_cd: event[p]["bud_cd"],
        prod_cd: event[p]["prod_cd"],
        proj_cd: event[p]["proj_cd"],
      });



    }

    let objdata: any = new Object();

    objdata["b_acct_id"] = this.b_acct_id;
    objdata["data"] = event_code_data;
    let datae = await this.createEventService.getMultipleEventForModule(objdata);

    let event_group_data = [];
    for (let i = 0; i < event.length; i++) {
      let obj: any = new Object();
      obj["evt_grp_dt"] = new Date().toISOString().split("T")[0];
      obj["bus_event_type"] = "CB_BILL";
      obj["demand_id"] = event[i]["cb_id"];
      obj["party_id"] = event[i]["party_id"];
      let ev_cd =
        event[i]["act_cd"] +
        event[i]["bud_cd"] +
        event[i]["prod_cd"] +
        event[i]["proj_cd"];
      obj["ev_ln_dist_bus_ev_cd"] = datae["data"][ev_cd]["event_code"];
      obj["bank_acct_num"] = null;
      obj["invoice_id"] = event[i]["cb_id"];
      obj["create_user_id"] = this.erpUser["user_id"];
      obj["arr_num"] = event[i]["work_id"];
      obj["ar_num_in_src"] = event[i]["work_id"];
      obj["ar_instr_cd"] = event[i]["work_id"];
      obj["cp_num_in_src"] = event[i]["party_id"];
      obj["cp_nm"] = mainObj['party_name']  // this.partyNameObj[this.AllworkObj[event[i]["work_id"]]["party_le_id"]];

      obj["ev_grp_amt"] = event[i]["gross_amount"];
      obj["ev_grp_cts"] = event[i]["bill_date"].split("T")[0];
      obj["ev_grp_ets"] = new Date().toISOString().split("T")[0];
      obj["ev_grp_id"] = event[i]["cb_id"];
      obj["ev_grp_lcl_unq_num_in_src"] = event[i]["cb_id"];
      obj["ev_grp_src_cd"] = "ACCOUNT";
      obj["ev_grp_tcd"] = "CB_BILL";
      obj["ev_ln_amt"] = Number(event[i]["amt"].toFixed(2));
      obj["ev_ln_cmnt"] = event[i]["event_rule"]; //
      obj["ev_ln_dist_aff_cc_cd"] = 0;
      obj["ev_ln_dist_bdgt_cd"] = event[i]["bud_cd"];
      obj["ev_ln_dist_cc_cd"] = this.hierobj["project"][event[i]["proj_cd"]]["lvl2_cd"]; //cost center
      obj["ev_ln_dist_pd_cd"] = event[i]["prod_cd"];
      obj["ev_ln_dist_prj_cd"] = event[i]["proj_cd"];
      obj["ev_ln_num"] = event[i]["cb_id"];
      obj["ev_ln_org_cd"] = this.erpUser["account_short_name"];
      obj["ev_ln_sku_desc"] = mainObj["work_desc"];
      obj["ev_ln_sku_tcd"] = 0;
      obj["ev_ln_bndl_qty"] = 0;
      obj["ev_ln_calc_total_item_qty"] = 0;
      obj["ev_ln_dist_amt"] = Number(event[i]["amt"].toFixed(2));
      obj["ev_ln_dist_curr_cd"] = "INR";
      obj["ev_ln_dist_num"] = 0;
      obj["ev_ln_dist_rt"] = 0;
      obj["ev_ln_dscnt_amt"] = 0;
      obj["ev_ln_dscnt_rt"] = 0;
      obj["ev_ln_eff_calc_item_rate"] = 0;
      obj["ev_ln_item_per_pkt_qty"] = 0;
      obj["ev_ln_item_rt"] = 0;
      obj["ev_ln_manual_override_item_rt"] = 0;
      obj["ev_ln_pkt_per_bndl_qty"] = 0;
      obj["ev_ln_tax_incl_rt"] = 0;
      obj["pmt_txn_id"] = 0;
      obj["ev_ln_dist_id"] = 0;
      obj["ev_ln_dist_tcd"] = "DOCUMENT LINE";
      obj["ev_ln_id"] = event[i]["event_cd"];
      obj["ev_ln_tcd"] = "DOCUMENT LINE";
      obj["pmt_cp_ar_src_cd"] = 0;
      obj["pmt_cp_ar_num_in_src"] = 0;
      obj["pmt_cp_ar_instr_cd"] = 0;
      obj["pmt_cp_num_in_src"] = 0;
      obj["pmt_cp_ev_grp_id"] = 0;
      obj["pmt_cp_ev_grp_src_cd"] = 0;
      obj["pmt_cp_ev_grp_tcd"] = 0;
      obj["pmt_cp_ev_grp_lcl_unq_num_in_src"] = 0;
      obj["pmt_cp_nm"] = 0;
      obj["pmt_rp_bnk_acct_id"] = 0;
      obj["pmt_cp_bnk_acct_id"] = 0;
      obj["pmt_cp_txn_id"] = 0;

      event_group_data.push(Object.assign({}, obj));
    }

    let eventgroupobj: any = new Object();

    let netPayable = Number(event[0]["net_amount"].toFixed(0));
    eventgroupobj["is_rec_or_pay"] = "PAYABLE";
    eventgroupobj["local_doc_no"] = event[0]["cb_id"];
    eventgroupobj["local_doc_desc"] = this.postpixAdd(countBill) + " bill of " + mainObj['party_name'] + " for " + mainObj["work_desc"]
    eventgroupobj["module_cd"] = "ACCOUNT";
    eventgroupobj["module_doc_type"] = "CB_BILL";
    eventgroupobj["status"] = "APPROVED";
    eventgroupobj["total_amt"] = netPayable;
    eventgroupobj["doc_type"] = "CB_BILL";
    eventgroupobj["data"] = event_group_data;
    eventgroupobj["create_user_id"] = this.erpUser["user_id"];
    eventgroupobj["b_acct_id"] = this.erpUser["b_acct_id"];
    eventgroupobj["req_data"] = JSON.stringify({ bill_id: event[0]["cb_id"], node_cd: event[0]["work_id"] })
    let resp1 = await this.createEventService.createevent(eventgroupobj);
    if (resp1["error"] == false) {
      // this.log.createLog({ ...this.logObj, activity: 'CREATE', message: "EVENT CREATED SUCCESSFULLY" })
      var obj1: any = new Object();


      obj1["b_acct_id"] = this.b_acct_id;
      obj1["cb_id"] = cb_id;
      obj1["status"] = "ACCEPTED";
      obj1["update_user_id"] = this.erpUser.user_id;
      this.spinner.show();
      var resp = await this.billService.acceptCb(obj1);
      if (resp["error"] == false) {
        this.spinner.hide();
        return true;
        // Swal.fire("Success", "Accepted Successfully!", "success");
      } else {
        this.spinner.hide();
        Swal.fire("Error", "...Error while accepting bill !", "error");
        return false
      }
    } else {
      Swal.fire("Error", "...Error while accepting bill !", "error");
      return false;
    }
    this.spinner.hide();
  }

  /**************************************Accepting Bill End ************************************************************ */


  async acceptPoReimbursement(element: any) {
    await this.getDedData();
    const rem_data = await this.reimbursementService.getPOandReimbursement(JSON.stringify({ b_acct_id: this.b_acct_id, rem_id: element.doc_local_no }))
    if (rem_data['error'] || rem_data['data'].length === 0) {
      Swal.fire("Error", "...Error while approving Po Reimbursement bill !", "error");
      return false;
    }


    await this.getAllProject();
    await this.getAllActivity();
    await this.getAllProduct();
    await this.getAllBudget();
    // await this.getgst();
    // await this.getAccountProjectHierarchy();
    this.spinner.show()
    // let current_cb: any = this.allCbObj[element.doc_local_no]
    // let countBill = this.countBill(current_cb)
    // let cb_id = [current_cb.cb_id];
    let event: any = [];
    let mainObj: any = new Object();
    mainObj = rem_data['data'][0];
    // mainObj["cb_date"] = current_cb.cb_date;
    // mainObj["bill_date"] = current_cb.bill_date;
    // mainObj["bill_no"] = current_cb.bill_no;
    // mainObj["status"] = current_cb.status;
    // mainObj["work_id"] = current_cb.work_id;



    // let ob = JSON.parse(current_cb.data);



    // mainObj["act_cd"] = current_cb.act_cd;

    // mainObj["work_desc"] = ob['work_desc'] //this.AllworkObj[this.obj["work_id"]]["work_desc"];
    // mainObj["party_le_id"] = ob['party_le_id'] //this.AllworkObj[this.obj["work_id"]]["party_le_id"];
    // mainObj["proj_cd"] = ob['proj_cd'] //this.AllworkObj[this.obj["work_id"]]["proj_cd"];
    // mainObj["bud_cd"] = ob['bud_cd'] //this.AllworkObj[this.obj["work_id"]]["bud_cd"];
    // mainObj["prod_cd"] = ob['prod_cd'] //this.AllworkObj[this.obj["work_id"]]["prod_cd"];
    // mainObj["act_cd"] = ob['act_cd'] //this.AllworkObj[this.obj["work_id"]]["act_cd"];
    // mainObj['party_name'] = ob['party_name']
    // console.log(obj);

    // mainObj["party_phone_no"] = ob["party_phone_no"];
    // mainObj["party_gstin_no"] = ob["party_gstin_no"];
    // mainObj["party_email"] = ob["party_email"];


    let AllRowDataLine = JSON.parse(rem_data['data'][0]['data_line'])//ob["payable_rows"];

    // let selectObj: any = Object.assign({}, ob["selectObj"]);
    // await this.check();

    let amountObj: any = {}
    amountObj['total_amount'] = 0;
    amountObj['net_amount'] = 0;
    amountObj['cgst_amount'] = 0;
    amountObj['sgst_amount'] = 0;
    amountObj['igst_amount'] = 0;

    AllRowDataLine.map((x: any) => {
      amountObj['total_amount'] += x['amount']
      amountObj['cgst_amount'] += x['cgst'];
      amountObj['sgst_amount'] += x['sgst'];
      amountObj['igst_amount'] += x['igst'];
      amountObj['net_amount'] += x['total_amount']


    })


    if (!this.dedtoActivity["CGSTINPUTNA"] || !this.dedtoBudeget["CGSTINPUTNA"]) {
      Swal.fire('INFO', 'Please select dedution mapping of CGSI INPUT')
      return false
    }
    if (!this.dedtoActivity["SGSTINPUTNA"] || !this.dedtoBudeget["SGSTINPUTNA"]) {
      Swal.fire('INFO', 'Please select dedution mapping of SGSI INPUT')
      return false
    }
    if (!this.dedtoActivity["IGSTINPUTNA"] || !this.dedtoBudeget["IGSTINPUTNA"]) {
      Swal.fire('INFO', 'Please select dedution mapping of IGSI INPUT')
      return false
    }




    let total_net: any = new Object();
    total_net["proj_cd"] = mainObj['proj_cd']
    total_net["bud_cd"] = mainObj["bud_cd"];
    total_net["prod_cd"] = mainObj["prod_cd"];
    total_net["act_cd"] = mainObj["act_cd"];
    total_net["amt"] = parseFloat(amountObj['total_amount'].toFixed(2)); parseFloat(this.totalAmount.toFixed(2));
    total_net["net_amount"] = parseFloat(amountObj['net_amount'].toFixed(2)); //this.net_amount;
    total_net["gross_amount"] = parseFloat(amountObj['total_amount'].toFixed(2));//this.totalAmount;
    total_net["party_id"] = mainObj["create_user_id"];
    total_net["rem_id"] = mainObj["rem_id"];
    total_net["req_date"] = mainObj["req_date"];
    total_net["event_cd"] = mainObj["rem_id"];
    total_net["event_rule"] = "NA";
    if (total_net["amt"] != 0) {
      event.push(total_net);
    }
    let total_cgst: any = new Object();
    total_cgst["proj_cd"] = mainObj['proj_cd']//this.projectLeafUserObj["ACCOUNTWORK" + mainObj["work_id"]]["leaf_cd"];
    total_cgst["bud_cd"] = this.dedtoBudeget["CGSTINPUTNA"];
    total_cgst["prod_cd"] = mainObj["prod_cd"];
    total_cgst["act_cd"] = this.dedtoActivity["CGSTINPUTNA"];
    total_cgst["amt"] = parseFloat(amountObj['cgst_amount'].toFixed(2));//this.cgstAmount;
    total_cgst["net_amount"] = parseFloat(amountObj['net_amount'].toFixed(2)) //this.net_amount;
    total_cgst["gross_amount"] = parseFloat(amountObj['total_amount'].toFixed(2))  //this.totalAmount;
    total_cgst["party_id"] = mainObj["create_user_id"];
    total_cgst["rem_id"] = mainObj["rem_id"];
    total_cgst["event_cd"] = "CGSTINPUT";
    total_cgst["event_rule"] = "NA";

    if (total_cgst["amt"] != 0) {
      event.push(total_cgst);
    }

    let total_sget: any = new Object();
    total_sget["proj_cd"] = mainObj['proj_cd']// this.projectLeafUserObj["ACCOUNTWORK" + mainObj["work_id"]]["leaf_cd"];
    total_sget["bud_cd"] = this.dedtoBudeget["SGSTINPUTNA"];
    total_sget["prod_cd"] = mainObj["prod_cd"];
    total_sget["act_cd"] = this.dedtoActivity["SGSTINPUTNA"];
    total_sget["amt"] = parseFloat(amountObj['sgst_amount'].toFixed(2))//this.sgstAmount;
    total_sget["net_amount"] = parseFloat(amountObj['net_amount'].toFixed(2))//this.net_amount;
    total_sget["gross_amount"] = parseFloat(amountObj['total_amount'].toFixed(2)) //this.totalAmount;
    total_sget["party_id"] = mainObj["create_user_id"];
    // total_sget["work_id"] = mainObj["work_id"];
    // total_sget["bill_date"] = mainObj["bill_date"];

    total_sget["rem_id"] = mainObj["rem_id"];
    total_sget["event_cd"] = "SGSTINPUT";
    total_sget["event_rule"] = "NA";

    if (total_sget["amt"] != 0) {
      event.push(total_sget);
    }

    let total_igst: any = new Object();
    total_igst["proj_cd"] = mainObj['proj_cd'] // this.projectLeafUserObj["ACCOUNTWORK" + mainObj["work_id"]]["leaf_cd"];
    total_igst["bud_cd"] = this.dedtoBudeget["IGSTINPUTNA"];
    total_igst["prod_cd"] = mainObj["prod_cd"];
    total_igst["act_cd"] = this.dedtoActivity["IGSTINPUTNA"];
    total_igst["amt"] = parseFloat(amountObj['igst_amount'].toFixed(2)) //this.igstAmount;
    total_igst["net_amount"] = parseFloat(amountObj['net_amount'].toFixed(2)) //this.net_amount;
    total_igst["gross_amount"] = parseFloat(amountObj['total_amount'].toFixed(2)) //this.totalAmount;
    total_igst["party_id"] = mainObj["party_le_id"];
    total_igst["net_amount"] = parseFloat(amountObj['net_amount'].toFixed(2))//this.net_amount;
    total_igst["gross_amount"] = parseFloat(amountObj['total_amount'].toFixed(2)) //this.totalAmount;
    total_igst["party_id"] = mainObj["create_user_id"];
    // total_sget["work_id"] = mainObj["work_id"];
    // total_sget["bill_date"] = mainObj["bill_date"];

    total_igst["rem_id"] = mainObj["rem_id"];
    total_igst["event_cd"] = "IGSTINPUT";
    total_igst["event_rule"] = "NA";

    if (total_igst["amt"] != 0) {
      event.push(total_igst);
    }

    if (event.length == 0) {
      Swal.fire("Warning", "All Event are with 0 amount...", "warning");
      return;
    }

    let event_code_data = [];
    for (let p = 0; p < event.length; p++) {

      event_code_data.push({
        act_value: this.activityObj[event[p]["act_cd"]],  //this.hierobj["activity"][event[p]["act_cd"]]["leaf_value"],
        bud_value: this.budgetObj[event[p]["bud_cd"]], //this.hierobj["budget"][event[p]["bud_cd"]]["leaf_value"],
        prod_value: this.productObj[event[p]["prod_cd"]], //this.hierobj["product"][event[p]["prod_cd"]]["leaf_value"],
        proj_value: this.prohierObj[event[p]["proj_cd"]], //this.hierobj["project"][event[p]["proj_cd"]]["leaf_value"],
        act_cd: event[p]["act_cd"],
        bud_cd: event[p]["bud_cd"],
        prod_cd: event[p]["prod_cd"],
        proj_cd: event[p]["proj_cd"],
      });



    }

    let objdata: any = new Object();

    objdata["b_acct_id"] = this.b_acct_id;
    objdata["data"] = event_code_data;
    let datae = await this.createEventService.getMultipleEventForModule(objdata);
    if (datae['error']) {
      Swal.fire("Error", "...Error while PO Reimbursement bill !", "error");
      return true;
    }
    let event_group_data = [];
    for (let i = 0; i < event.length; i++) {
      let obj: any = new Object();
      obj["evt_grp_dt"] = new Date().toISOString().split("T")[0];
      obj["bus_event_type"] = "PO_REIMBURSEMENT";
      obj["demand_id"] = event[i]["rem_id"];
      obj["party_id"] = event[i]["party_id"];
      let ev_cd = event[i]["bud_cd"] + "_" + event[i]["prod_cd"] + "_" + event[i]["proj_cd"] + "_" + event[i]["act_cd"]
      obj["ev_ln_dist_bus_ev_cd"] = ev_cd;
      obj["bank_acct_num"] = mainObj['acct_no'];
      obj["invoice_id"] = event[i]["rem_id"];
      obj["create_user_id"] = this.erpUser["user_id"];
      obj["arr_num"] = event[i]["rem_id"];
      obj["ar_num_in_src"] = event[i]["rem_id"];
      obj["ar_instr_cd"] = event[i]["rem_id"];
      obj["cp_num_in_src"] = event[i]["party_id"];
      obj["cp_nm"] = mainObj['emp_name']  // this.partyNameObj[this.AllworkObj[event[i]["work_id"]]["party_le_id"]];

      obj["ev_grp_amt"] = event[i]["gross_amount"];
      obj["ev_grp_cts"] = mainObj["req_date"];
      obj["ev_grp_ets"] = new Date().toISOString().split("T")[0];
      obj["ev_grp_id"] = event[i]["rem_id"];
      obj["ev_grp_lcl_unq_num_in_src"] = event[i]["rem_id"];
      obj["ev_grp_src_cd"] = "ACCOUNT";
      obj["ev_grp_tcd"] = "PO_REMBURSEMENT";
      obj["ev_ln_amt"] = Number(event[i]["amt"].toFixed(2));
      obj["ev_ln_cmnt"] = event[i]["event_rule"]; //
      obj["ev_ln_dist_aff_cc_cd"] = 0;
      obj["ev_ln_dist_bdgt_cd"] = event[i]["bud_cd"];
      obj["ev_ln_dist_cc_cd"] = this.hierobj["project"][event[i]["proj_cd"]]["lvl2_cd"]; //cost center
      obj["ev_ln_dist_pd_cd"] = event[i]["prod_cd"];
      obj["ev_ln_dist_prj_cd"] = event[i]["proj_cd"];
      obj["ev_ln_num"] = event[i]["rem_id"];
      obj["ev_ln_org_cd"] = this.erpUser["account_short_name"];
      obj["ev_ln_sku_desc"] = mainObj["event_desc"];
      obj["ev_ln_sku_tcd"] = 0;
      obj["ev_ln_bndl_qty"] = 0;
      obj["ev_ln_calc_total_item_qty"] = 0;
      obj["ev_ln_dist_amt"] = Number(event[i]["amt"].toFixed(2));
      obj["ev_ln_dist_curr_cd"] = "INR";
      obj["ev_ln_dist_num"] = 0;
      obj["ev_ln_dist_rt"] = 0;
      obj["ev_ln_dscnt_amt"] = 0;
      obj["ev_ln_dscnt_rt"] = 0;
      obj["ev_ln_eff_calc_item_rate"] = 0;
      obj["ev_ln_item_per_pkt_qty"] = 0;
      obj["ev_ln_item_rt"] = 0;
      obj["ev_ln_manual_override_item_rt"] = 0;
      obj["ev_ln_pkt_per_bndl_qty"] = 0;
      obj["ev_ln_tax_incl_rt"] = 0;
      obj["pmt_txn_id"] = 0;
      obj["ev_ln_dist_id"] = 0;
      obj["ev_ln_dist_tcd"] = "DOCUMENT LINE";
      obj["ev_ln_id"] = event[i]["event_cd"];
      obj["ev_ln_tcd"] = "DOCUMENT LINE";
      obj["pmt_cp_ar_src_cd"] = 0;
      obj["pmt_cp_ar_num_in_src"] = 0;
      obj["pmt_cp_ar_instr_cd"] = 0;
      obj["pmt_cp_num_in_src"] = 0;
      obj["pmt_cp_ev_grp_id"] = 0;
      obj["pmt_cp_ev_grp_src_cd"] = 0;
      obj["pmt_cp_ev_grp_tcd"] = 0;
      obj["pmt_cp_ev_grp_lcl_unq_num_in_src"] = 0;
      obj["pmt_cp_nm"] = 0;
      obj["pmt_rp_bnk_acct_id"] = 0;
      obj["pmt_cp_bnk_acct_id"] = 0;
      obj["pmt_cp_txn_id"] = 0;

      event_group_data.push(Object.assign({}, obj));
    }

    let eventgroupobj: any = new Object();

    let netPayable = Number(event[0]["net_amount"].toFixed(0));
    eventgroupobj["is_rec_or_pay"] = "PAYABLE";
    eventgroupobj["local_doc_no"] = event[0]["rem_id"];
    eventgroupobj["local_doc_desc"] = "Reimbursement BIll Of " + mainObj['emp_name']
    eventgroupobj["module_cd"] = "ACCOUNT";
    eventgroupobj["module_doc_type"] = "PO_REIMBURSEMENT_BILL";
    eventgroupobj["status"] = "APPROVED";
    eventgroupobj["total_amt"] = netPayable;
    eventgroupobj["doc_type"] = "PO_REIMBURSEMENT_BILL";
    eventgroupobj["data"] = event_group_data;
    eventgroupobj["create_user_id"] = this.erpUser["user_id"];
    eventgroupobj["b_acct_id"] = this.erpUser["b_acct_id"];
    eventgroupobj["req_data"] = JSON.stringify({ bill_id: event[0]["rem_id"], node_cd: mainObj['proj_cd'] })
    let resp1 = await this.createEventService.createevent(eventgroupobj);
    if (resp1["error"] == false) {
      return true
    } else {
      Swal.fire("Error", "...Error while PO Reimbursement bill !", "error");
      return false;
    }
  }
  /**************************************Accepting Po Reimbursement End ************************************************************ */


}
